import React, { useEffect, useState } from 'react';
import Archive from '../categories/Archive';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getAllCategories } from '../../service/categoryService';
import LoadingBar from '../shared/EclipseLoading';
import socket from '../../service/socket';

const Categoies = () => {

    const [categories, setCategories] = useState();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllCategories = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getAllCategories({ signal: cancelRequest.signal }, 'exceptAndSoOn');
                if (status === 201)
                    setCategories(data.categories)
                setIsLoading(false);
            } catch (err) {
            }
        }
        fetchAllCategories();
        return () => {
            cancelRequest.cancel();
        }
    }, []);

    useEffect(() => {

        socket.on('category', data => {
            if (data.action === 'create') {
                const prevCategories = [...categories]
                const findIndex = prevCategories.findIndex(item => item._id === data.createdCategory._id);
                if (findIndex <= -1) {
                    prevCategories.push(data.createdCategory);
                    setCategories(prevCategories)
                }
            }
            else if (data.action === 'update') {
                const prevProjects = [...categories]
                const findIndex = prevProjects.findIndex(item => item._id === data.updatedCategory._id);
                if (findIndex > -1) {
                    prevProjects[findIndex] = data.updatedCategory;
                    setCategories(prevProjects)
                }
            }
            else if (data.action === 'delete') {
                const prevCategories = [...categories]
                const newCategories = prevCategories.filter(item => item._id !== data.categoryId)
                setCategories(newCategories)
            }
        })

        return () => {
            socket.off('category');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categories])

    return (
        <div>
            {
                (!categories || isLoading) ?
                    <section style={{
                        height: '60vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    >
                        <LoadingBar classNames={`ldio-text-danger`} />
                    </section>
                    :
                    <Archive
                        categories={categories}
                    />
                }
        </div>
    );
}

export default Categoies;